export default __webpack_public_path__ + "static/media/help-page-layer-panel.da594cf2.jpg";